import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { projectStrategicAxis }: Boundaries["editProjectStrategicAxis"]["request"],
): State {
  const index = state.findIndex(
    (res) => res.projectStrategicAxis.uuid === projectStrategicAxis.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { projectStrategicAxis, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { projectStrategicAxis, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { projectStrategicAxis }: Boundaries["editProjectStrategicAxis"]["success"],
): State {
  return state.map((res) =>
    res.projectStrategicAxis.uuid === projectStrategicAxis.uuid
      ? { projectStrategicAxis, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  { projectStrategicAxis }: Boundaries["editProjectStrategicAxis"]["failure"],
): State {
  return state.map((res) =>
    res.projectStrategicAxis.uuid === projectStrategicAxis.uuid
      ? { projectStrategicAxis, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editProjectStrategicAxisRequested]: handleRequest,
    [events.editProjectStrategicAxisSucceeded]: handleSuccess,
    [events.editProjectStrategicAxisFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
